var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-item history-visible",
      attrs: { id: "appraisal-process-history" },
    },
    [
      _c(
        "AppraisalHistoryFilter",
        _vm._g({ attrs: { id: "appraisals-filter" } }, _vm.$listeners)
      ),
      _c("AppraisalHistoryList", {
        attrs: { id: "appraisals-list", "appraisal-list": _vm.appraisalList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }